import React from 'react'

const DLM3000 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <a href="/">Oscilloscopes</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Mixed Signal Oscilloscope </span>
                        <i class="fa fa-angle-right"></i>
                        <span>DLM3000</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/dlm7.png' width={400} style={{ marginTop: "80px", marginLeft: "90px" }}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>DLM3000:</h2>
                        <p class="mbot25">
                            DLM3000 builds on Yokogawa’s oscilloscope legacy with new features
                            focusing on quality, flexibility and usability to increase our users’ productivity and meet
                            the advanced needs of today’s mechatronics designs.
                            Integrating the latest in touchscreen operation, solid-state storage, and high
                            speed signal processing, the DLM3000 enhances productivity by providing clean
                            signals, extensive processing, and ease of operation.
                        </p>
                        <p class="mbot25">
                            <img src='/img/dlm7Table.png' className='tableimg' />
                        </p>
                    </div> 
                </div>
            </div>
        </div>
    )
}

export default DLM3000
